import { IStoreState } from "@montana/store/store";
import { IPageContainerState } from "./page";
import { generateContainer, IContainerProps } from "../base/generate-container";
import { setPageTheme, setPageHasHero, setPageIsTransitioning } from './page.actions';

const mapState = ({ page }: IStoreState): IPageContainerState => ({ ...page });

const actions = {
    setPageTheme,
    setPageHasHero,
    setPageIsTransitioning
};

export type IPageContainerProps = IContainerProps<ReturnType<typeof mapState>, typeof actions>;

export const [PageContainer, connectWithPage, usePage] = generateContainer(mapState, actions);
